import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    SEARCH: '',
    ACTIVITY: ['ALL'],
    DIFFICULTY: ['ALL'],
    PRIMARY_MUSCLES: ['ALL'],
    DURATION: ['ALL'],
    GOALS: ['ALL'],
    SPORT_TYPES: ['ALL']
};

const updateWorkoutsFilter = (state, action) => {
    return {
        ...state,
        SEARCH: action.enabledFilters.SEARCH,
        ACTIVITY: action.enabledFilters.ACTIVITY,
        DIFFICULTY: action.enabledFilters.DIFFICULTY,
        PRIMARY_MUSCLES: action.enabledFilters.PRIMARY_MUSCLES,
        DURATION: action.enabledFilters.DURATION,
        SPORT_TYPES: action.enabledFilters.SPORT_TYPES
    };
};

const resetWorkoutsFilter = () => {
    return {
        SEARCH: '',
        ACTIVITY: ['ALL'],
        DIFFICULTY: ['ALL'],
        PRIMARY_MUSCLES: ['ALL'],
        DURATION: ['ALL'],
        GOALS: ['ALL'],
        SPORT_TYPES: ['ALL']
    };
};

const handlers = {
    [types.UPDATE_WORKOUTS_FILTER]: updateWorkoutsFilter,
    [types.RESET_WORKOUTS_FILTER]: resetWorkoutsFilter
};

export const getWorkoutsFilter = (state) => {
    return state.workoutsFilter;
};

export default function workoutsFilter(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
